import { Component } from '@angular/core'
import { Colors } from '../ColorPalette'

export interface ColorGroup {
  colorName: string
  colorHex: string
  weight?: number
  children?: ColorGroup[]
}

const convertToColorGroup = (name: string): ColorGroup => ({
  colorName: `color${name}`,
  colorHex: Colors[name as unknown as keyof typeof Colors],
  children: [90, 80, 70, 60, 40, 30, 20, 10].map(weight => ({
    colorName: `color-${name.toLowerCase()}-${weight}`,
    colorHex: Colors[`${name}${weight}` as unknown as keyof typeof Colors],
    weight,
  })),
})

const MAIN_COLORS = ['Brand', 'Primary', 'Secondary']

const COMPLEMENTARY_COLORS = ['Watermelon', 'Mandarin', 'Lemon', 'Apple', 'Aqua', 'Blueberry', 'Grape']

const COLOR_GROUPS: ColorGroup[] = [
  ...MAIN_COLORS.map(color => convertToColorGroup(color)),
  {
    colorName: 'colorGrey',
    colorHex: Colors.Grey,
    children: [
      { colorName: 'colorGreyDark', colorHex: Colors.GreyDark, weight: 90 },
      { colorName: 'colorGreyLight', colorHex: Colors.GreyLight, weight: 70 },
      { colorName: 'colorGreyLighter', colorHex: Colors.GreyLighter, weight: 30 },
      { colorName: 'colorGrey20', colorHex: Colors.Grey20, weight: 20 },
      { colorName: 'colorGreyLightest', colorHex: Colors.GreyLightest, weight: 10 },
    ],
  },
  {
    colorName: 'colorError',
    colorHex: Colors.Error,
  },
  {
    colorName: 'colorBlack',
    colorHex: Colors.Black,
  },
  {
    colorName: 'colorWhite',
    colorHex: Colors.White,
  },
  ...COMPLEMENTARY_COLORS.map(color => convertToColorGroup(color)),
]

@Component({
  selector: 'ftr-color-palette',
  templateUrl: './color-palette.component.html',
  styleUrls: ['./color-palette.component.css'],
})
export class ColorPaletteComponent {
  colorGroups: ColorGroup[]

  constructor() {
    this.colorGroups = COLOR_GROUPS
  }
}
